import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MaterialIcon from "material-icons-react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Form, Input, Tabs, message, Spin } from "antd";
import { Checkbox } from "antd";

import {
  SaveJobDocuments,
  SaveJobHistory,
  fetchAppliedJobs,
  fetchJobInfo,
  saveAcQualifications,
  saveJobApplication,
} from "../../features/job/jobSlice";
import moment from "moment";
import ProfileApplyDrawer from "./drawer/ProfileApplyDrawer";
import GlobalScroll from "../srolls/GlobalScroll";
import Dragger from "antd/es/upload/Dragger";
import { fetchAttachments } from "../../features/doc/docSlice";
import {
  fetchEducations,
  fetchProfessional,
} from "../../features/edu/eduSlice";
import { fetchExperiences } from "../../features/exp/expSlice";
import TermsOfService from "../profile/build_profile/TermsOfService";

const url = process.env.REACT_APP_API_BASE_URL;

export default function JobInfo() {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.auth);
  const { activeJob } = useSelector((state) => state.job);
  const { experiences } = useSelector((state) => state.exp);
  const { educations, professional } = useSelector((state) => state.edu);
  const { docs, docLoading } = useSelector((state) => state.doc);

  const [resp, setresp] = useState([]);
  const [keySkills, setkeySkills] = useState([]);
  const [reqs, setreqs] = useState([]);
  const [open, setOpen] = useState(false);
  const [fileUrl, setfileUrl] = useState("");
  const [fileName, setfileName] = useState("");
  const [checked, setChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  console.log("checked", checked);
  const usrObj = {
    usrId: user?.usrId,
  };

  const fetchData = async () => {
    console.log("Fetching data...");
    const resp = await dispatch(fetchAttachments(usrObj));
    const edu = await dispatch(fetchEducations(usrObj));
    const exp = await dispatch(fetchExperiences(usrObj));
    const pro = await dispatch(fetchProfessional(usrObj));
  };

  const onClose = () => {
    setOpen(false);
  };

  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
    setChecked(e.target.checked);
  };

  async function handleFetchJobInfo() {
    const usrObj = {
      jbdJobId: activeJob?.jobId,
    };
    const res = await dispatch(fetchJobInfo(usrObj));
  }

  const props = {
    name: "file",
    multiple: false,
    accept: "image/png, image/jpeg, .pdf",
    action: `${url}/nea/saveFile.action`,
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
        if (info?.file?.response?.success) {
          setfileUrl(info?.file?.response?.jsonData);
          setfileName(info?.file?.name);
        } else {
          setfileUrl("");
          setfileName("");
        }
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  useEffect(() => {
    fetchData();
  }, []);

  let qualification = activeJob.hrjobQualifications;
  let requirements = activeJob.hrjobRequirements;
  let responsibilities = activeJob.hrjobResponsibilities;

  const JobQualificationElement = qualification.map((qua, index) => (
    <li key={index}>{qua.description}</li>
  ));

  const JobRequirementElement = requirements.map((qua, index) => (
    <li key={index}>{qua.description}</li>
  ));

  const JobResponsibilityElement = responsibilities.map((qua, index) => (
    <li key={index}>{qua.description}</li>
  ));

  const usrDob = moment(user.usrDob);
  const currentDate = moment();

  const onFinish = async (data) => {
    if (currentDate.diff(usrDob, "years") > 60) {
      message.error(
        "Application Failed, You are beyond the age limit required"
      );
      return;
    }

    if (currentDate.diff(usrDob, "years") < 18) {
      message.error("Application Failed, You are below the age limit required");
      return;
    }

    if (!experiences.length || !educations.length) {
      message.error(`Kindly First fill in your Profile`);

      navigate("/profile");
      return;
    }

    const applicationData = {
      jobNo: activeJob.jobNo,
      jobTitle: activeJob.jobTitle,
      employeeRequisitionNo: activeJob.no,
      surname: user.usrLastName,
      firstName: user.usrFirstName,
      middleName: user.usrMiddleName === null ? "" : user.usrMiddleName,
      gender:
        user.usrGender == null ? "1" : user.usrGender === "Male" ? "1" : "2",
      dateOfBirth: moment(user.usrDob).format("YYYY-MM-DD"),
      age: currentDate.diff(usrDob, "years"),
      postalAddress: "N/A",
      residentialAddress: "N/A",
      cityOrTown: user.usrCounty,
      countyCode: "031",
      countyName: user.usrCounty,
      subCountyCode: "032",
      maritalStatus:
        user.usrMaritalStatus == null
          ? "1"
          : user.usrMaritalStatus === "Single"
          ? "1"
          : user.usrMaritalStatus === "Married"
          ? "2"
          : "3",
      subCountyName: "",
      ethnicGroup: user.usrEthnicity,
      religion: user.usrOtherTitle,
      country: user.usrNationality,
      alternativePhoneNo: "",
      mobilePhoneNo: user.usrMobileNumber,
      personalEmailAddress: user.usrEmail,
      drivingLicenceNo: "",
      citizenship: user.usrNationality,
      nationalIDNo: user.usrNationalId,
      expectedSalary: 1,
      olevelGrade: data.objGrade,
      yearOfExperience: data.objYear,
      declaration: "true",
    };

    setIsLoading(true);

    const res = await dispatch(saveJobApplication(applicationData));

    console.log(
      res.payload,
      "*******************JOB APP NUMBER  AND FILE**********************",
      fileUrl
    );

    if (res.payload.success === false) {
      console.log("MESSAGE: " + res.payload.messages.message);
      const part1 = "Client received SOAP Fault from server:";
      const part2 =
        "Please see the server log to find more detail regarding exact cause of the failure";
      setIsLoading(false);

      var info = res.payload.messages.message;

      const result = info.replace(part1, "").replace(part2, "").trim();

      message.error(result);
      return;
    }

    const jobAppNo = res.payload.messages.message;

    experiences.forEach((exp) => {
      const endDate = exp.expCurrent ? moment() : moment(exp.endEndDate);
      const StartDate = moment(exp.expStartDate);
      const data = {
        jobApplicationNo: jobAppNo,
        organization: exp?.expEmployer,
        organizationAddress: exp?.expEmployer,
        positionHeld: exp?.expDesc,
        fromDate: moment(exp?.expStartDate).format("YYYY-MM-DD"),
        toDate: moment(endDate).format("YYYY-MM-DD"),
        yearsOfService: endDate.diff(StartDate, "years"),
        grossSalary: "0",
        benefits: "none",
        email: "null",
        jobDescription: exp?.expDesc,
      };
      dispatch(SaveJobHistory(data));
    });

    educations.forEach((edu) => {
      const data = {
        jobApplicationNo: jobAppNo,
        qualificationCode: edu?.eduLevel,
        qualificationName: edu?.eduLevel,
        joiningDate: moment(edu?.eduStartDate).format("YYYY-MM-DD"),
        completionDate: moment(edu?.endEndDate).format("YYYY-MM-DD"),
        instutitionName: edu?.eduSchool,
        professionQualification: false,
        yearOfRegistration: moment(edu?.endEndDate).format("YYYY"),
        award: "0",
        awardDate: "2023-01-02",
        email: "",
      };
      dispatch(saveAcQualifications(data));
    });

    professional.forEach((edu) => {
      const data = {
        jobApplicationNo: jobAppNo,
        qualificationCode: edu?.eduLevel,
        qualificationName: edu?.eduLevel,
        joiningDate: "2023-01-02",
        completionDate: "2023-01-02",
        instutitionName: edu?.eduSchool,
        professionQualification: true,
        award: "0",
        awardDate: "2023-01-02",
        email: "",
        yearOfRegistration: moment(edu?.endEndDate).format("YYYY"),
      };
      dispatch(saveAcQualifications(data));
    });

    docs.forEach((att) => {
      const data = {
        jobApplicationNo: jobAppNo,
        documentDescription: `Cert Number: ${att?.attCertNumber}`,
        actualFileName: att?.attFile,
      };
      dispatch(SaveJobDocuments(data));
    });

    const cvData = {
      jobApplicationNo: jobAppNo,
      documentDescription: `RESUME`,
      actualFileName: fileUrl,
    };

    dispatch(SaveJobDocuments(cvData));

    message.success("Job Applied successfully");

    dispatch(fetchAppliedJobs(user.usrNationalId));

    setIsLoading(false);
    navigate("/");
    form.resetFields();
  };

  async function handleProfileApplication() {
    await setOpen(true);
    // await navigate("/profile")
  }

  useEffect(() => {
    handleFetchJobInfo();
  }, [activeJob]);

  return (
    <>
      <div className='m-[10px] md:mr-[108px] md:ml-[42px] md:mt-[15px]'>
        <div className='bg-white p-[53px]'>
          <div className='flex justify-between'>
            <h2 className='prof-name'>
              Like this <span className='text-[#147CBC]'>job</span>?
            </h2>
            <div className='flex items-center'>
              <button type='button' className='flex items-center justify-end'>
                <span className='bg-[#EDF8FF] rounded-full p-1'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='28'
                    height='24'
                    viewBox='0 0 28 24'
                    fill='none'
                  >
                    <path
                      d='M17.7692 18L11.0469 12L17.7692 6'
                      stroke='#147CBC'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                  </svg>
                </span>

                <span className='ml-4 go-back'>Go Back</span>
              </button>
            </div>
          </div>

          <div className='flex justify-between w-full'>
            <p className='prof-desc mt-2'>
              Send in your application if you feel this is a good fit for you.
            </p>

            <div className='flex items-center mt-6'>
              <div className='rounded-full p-1 bg-[#F4F9FB] cursor-pointer'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='30'
                  height='30'
                  viewBox='0 0 38 38'
                  fill='none'
                >
                  <circle cx='19' cy='19' r='19' fill='#F4F9FB' />
                  <path
                    d='M14 28.5122V13.3665C14 13.0021 14.1108 12.6833 14.3325 12.41C14.5542 12.1367 14.8128 12 15.1083 12H23.2361C23.5317 12 23.7903 12.1367 24.0119 12.41C24.2336 12.6833 24.3444 13.0021 24.3444 13.3665V28.5122L19.1722 25.7791L14 28.5122ZM15.1083 26.4396L19.1722 24.3215L23.2361 26.4396V13.3665H15.1083V26.4396Z'
                    fill='#333333'
                  />
                </svg>
              </div>

              <div className='rounded-full p-1 bg-[#F4F9FB] ml-3 cursor-pointer'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='22'
                  height='22'
                  viewBox='0 0 19 18'
                  fill='none'
                >
                  <path
                    d='M14.158 16.3872C13.573 16.3872 13.0758 16.1818 12.6663 15.7712C12.2569 15.3605 12.0521 14.8619 12.0521 14.2752C12.0521 14.1931 12.0614 14.0926 12.0798 13.9739C12.0983 13.8551 12.126 13.7483 12.163 13.6533L6.56587 10.4022C6.38115 10.6115 6.15332 10.7808 5.8824 10.9101C5.61147 11.0394 5.33439 11.1041 5.05115 11.1041C4.46619 11.1041 3.96898 10.8994 3.55951 10.4899C3.15005 10.0804 2.94531 9.58322 2.94531 8.99826C2.94531 8.41331 3.15005 7.9161 3.55951 7.50663C3.96898 7.09716 4.46619 6.89243 5.05115 6.89243C5.33439 6.89243 5.60531 6.94785 5.86392 7.05868C6.12253 7.16951 6.35652 7.32961 6.56587 7.53896L12.163 4.32479C12.126 4.23771 12.0983 4.13974 12.0798 4.03088C12.0614 3.92203 12.0521 3.81681 12.0521 3.71521C12.0521 3.13025 12.2569 2.63304 12.6663 2.22358C13.0758 1.81411 13.573 1.60938 14.158 1.60938C14.7429 1.60938 15.2401 1.81411 15.6496 2.22358C16.0591 2.63304 16.2638 3.13025 16.2638 3.71521C16.2638 4.30016 16.0591 4.79737 15.6496 5.20684C15.2401 5.61631 14.7429 5.82104 14.158 5.82104C13.8704 5.82104 13.5953 5.77486 13.3327 5.6825C13.0701 5.59014 12.8464 5.43928 12.6617 5.22993L7.06462 8.33326C7.08925 8.43178 7.1108 8.54569 7.12927 8.675C7.14774 8.80431 7.15698 8.91354 7.15698 9.00272C7.15698 9.0919 7.14774 9.18426 7.12927 9.2798C7.1108 9.37535 7.08925 9.47238 7.06462 9.5709L12.6617 12.7481C12.8464 12.5757 13.0619 12.4372 13.3082 12.3325C13.5545 12.2278 13.8378 12.1755 14.158 12.1755C14.7429 12.1755 15.2401 12.3802 15.6496 12.7897C16.0591 13.1992 16.2638 13.6964 16.2638 14.2813C16.2638 14.8663 16.0591 15.3635 15.6496 15.773C15.2401 16.1824 14.7429 16.3872 14.158 16.3872ZM14.1586 4.71271C14.4414 4.71271 14.6783 4.61705 14.8691 4.42574C15.06 4.23443 15.1555 3.99737 15.1555 3.71456C15.1555 3.43175 15.0598 3.19491 14.8685 3.00403C14.6772 2.81315 14.4401 2.71771 14.1573 2.71771C13.8745 2.71771 13.6377 2.81336 13.4468 3.00467C13.2559 3.19598 13.1605 3.43304 13.1605 3.71585C13.1605 3.99866 13.2561 4.23551 13.4474 4.42639C13.6387 4.61727 13.8758 4.71271 14.1586 4.71271ZM5.05179 9.99576C5.3346 9.99576 5.57145 9.90011 5.76233 9.7088C5.95321 9.51749 6.04865 9.28043 6.04865 8.99762C6.04865 8.71481 5.95299 8.47796 5.76168 8.28708C5.57037 8.0962 5.33331 8.00076 5.0505 8.00076C4.76769 8.00076 4.53084 8.09642 4.33997 8.28773C4.14909 8.47904 4.05365 8.7161 4.05365 8.99891C4.05365 9.28172 4.1493 9.51857 4.34061 9.70944C4.53192 9.90032 4.76898 9.99576 5.05179 9.99576ZM14.1586 15.2788C14.4414 15.2788 14.6783 15.1832 14.8691 14.9919C15.06 14.8005 15.1555 14.5635 15.1555 14.2807C15.1555 13.9979 15.0598 13.761 14.8685 13.5701C14.6772 13.3793 14.4401 13.2838 14.1573 13.2838C13.8745 13.2838 13.6377 13.3795 13.4468 13.5708C13.2559 13.7621 13.1605 13.9992 13.1605 14.282C13.1605 14.5648 13.2561 14.8016 13.4474 14.9925C13.6387 15.1834 13.8758 15.2788 14.1586 15.2788Z'
                    fill='#333333'
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className='bg-white p-[31px] w-full mt-7'>
          <div
            style={{
              border: "1px solid rgba(20, 20, 20, 0.05)",
            }}
            className='flex rounded-[8px] p-[24px] space-x-4 mb-4 bg-[#E8F4FF]'
          >
            <div className='flex-1 min-w-0'>
              <p className='text-black14 font-bold text-[21px]'>
                {activeJob?.jobTitle}
              </p>

              <div className='flex items-center mt-2'>
                <span className='p-1 bg-lightPurple text-darkPurple w-fit rounded-[5px] text-[14px] font-medium'>
                  Job Grade: {activeJob?.jobGrade}
                </span>

                <span className='p-1 bg-lightPurple text-darkPurple w-fit rounded-[5px] ml-4 text-[14px] font-medium'>
                  Job Reference No: {activeJob?.jobReferenceNo}
                </span>
              </div>

              <div className='flex justify-between items-center'>
                <div className='flex items-center flex-wrap text-[#147CBC] mt-3'>
                  <div className='flex items-center mr-7'></div>

                  <div className='flex items-center mr-7'>
                    <span className='font-medium text-[15px] ml-1'>
                      salary : Confidential
                    </span>
                  </div>

                  <div className='flex items-center mr-7'>
                    <MaterialIcon
                      size={20}
                      color='#147CBC'
                      icon='calendar_today'
                    />
                    {/* <span className='font-medium text-[14px] ml-1'>
                      Ends{" "}
                      {moment(activeJob?.jobCloseDate).startOf("day").fromNow()}
                    </span> */}
                  </div>
                </div>

                <div className='flex items-center'></div>
              </div>
            </div>
            <div className='inline-flex items-center'>
              <div className='flex flex-col'>
                <div className='flex !items-center'></div>

                <div className='flex items-center absolute bottom-5 right-5'>
                  <div className='rounded-full p-1 bg-[#F4F9FB] cursor-pointer'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='30'
                      height='30'
                      viewBox='0 0 38 38'
                      fill='none'
                    >
                      <circle cx='19' cy='19' r='19' fill='#F4F9FB' />
                      <path
                        d='M14 28.5122V13.3665C14 13.0021 14.1108 12.6833 14.3325 12.41C14.5542 12.1367 14.8128 12 15.1083 12H23.2361C23.5317 12 23.7903 12.1367 24.0119 12.41C24.2336 12.6833 24.3444 13.0021 24.3444 13.3665V28.5122L19.1722 25.7791L14 28.5122ZM15.1083 26.4396L19.1722 24.3215L23.2361 26.4396V13.3665H15.1083V26.4396Z'
                        fill='#333333'
                      />
                    </svg>
                  </div>

                  <div className='rounded-full p-1 bg-[#F4F9FB] ml-3 cursor-pointer'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='22'
                      height='22'
                      viewBox='0 0 19 18'
                      fill='none'
                    >
                      <path
                        d='M14.158 16.3872C13.573 16.3872 13.0758 16.1818 12.6663 15.7712C12.2569 15.3605 12.0521 14.8619 12.0521 14.2752C12.0521 14.1931 12.0614 14.0926 12.0798 13.9739C12.0983 13.8551 12.126 13.7483 12.163 13.6533L6.56587 10.4022C6.38115 10.6115 6.15332 10.7808 5.8824 10.9101C5.61147 11.0394 5.33439 11.1041 5.05115 11.1041C4.46619 11.1041 3.96898 10.8994 3.55951 10.4899C3.15005 10.0804 2.94531 9.58322 2.94531 8.99826C2.94531 8.41331 3.15005 7.9161 3.55951 7.50663C3.96898 7.09716 4.46619 6.89243 5.05115 6.89243C5.33439 6.89243 5.60531 6.94785 5.86392 7.05868C6.12253 7.16951 6.35652 7.32961 6.56587 7.53896L12.163 4.32479C12.126 4.23771 12.0983 4.13974 12.0798 4.03088C12.0614 3.92203 12.0521 3.81681 12.0521 3.71521C12.0521 3.13025 12.2569 2.63304 12.6663 2.22358C13.0758 1.81411 13.573 1.60938 14.158 1.60938C14.7429 1.60938 15.2401 1.81411 15.6496 2.22358C16.0591 2.63304 16.2638 3.13025 16.2638 3.71521C16.2638 4.30016 16.0591 4.79737 15.6496 5.20684C15.2401 5.61631 14.7429 5.82104 14.158 5.82104C13.8704 5.82104 13.5953 5.77486 13.3327 5.6825C13.0701 5.59014 12.8464 5.43928 12.6617 5.22993L7.06462 8.33326C7.08925 8.43178 7.1108 8.54569 7.12927 8.675C7.14774 8.80431 7.15698 8.91354 7.15698 9.00272C7.15698 9.0919 7.14774 9.18426 7.12927 9.2798C7.1108 9.37535 7.08925 9.47238 7.06462 9.5709L12.6617 12.7481C12.8464 12.5757 13.0619 12.4372 13.3082 12.3325C13.5545 12.2278 13.8378 12.1755 14.158 12.1755C14.7429 12.1755 15.2401 12.3802 15.6496 12.7897C16.0591 13.1992 16.2638 13.6964 16.2638 14.2813C16.2638 14.8663 16.0591 15.3635 15.6496 15.773C15.2401 16.1824 14.7429 16.3872 14.158 16.3872ZM14.1586 4.71271C14.4414 4.71271 14.6783 4.61705 14.8691 4.42574C15.06 4.23443 15.1555 3.99737 15.1555 3.71456C15.1555 3.43175 15.0598 3.19491 14.8685 3.00403C14.6772 2.81315 14.4401 2.71771 14.1573 2.71771C13.8745 2.71771 13.6377 2.81336 13.4468 3.00467C13.2559 3.19598 13.1605 3.43304 13.1605 3.71585C13.1605 3.99866 13.2561 4.23551 13.4474 4.42639C13.6387 4.61727 13.8758 4.71271 14.1586 4.71271ZM5.05179 9.99576C5.3346 9.99576 5.57145 9.90011 5.76233 9.7088C5.95321 9.51749 6.04865 9.28043 6.04865 8.99762C6.04865 8.71481 5.95299 8.47796 5.76168 8.28708C5.57037 8.0962 5.33331 8.00076 5.0505 8.00076C4.76769 8.00076 4.53084 8.09642 4.33997 8.28773C4.14909 8.47904 4.05365 8.7161 4.05365 8.99891C4.05365 9.28172 4.1493 9.51857 4.34061 9.70944C4.53192 9.90032 4.76898 9.99576 5.05179 9.99576ZM14.1586 15.2788C14.4414 15.2788 14.6783 15.1832 14.8691 14.9919C15.06 14.8005 15.1555 14.5635 15.1555 14.2807C15.1555 13.9979 15.0598 13.761 14.8685 13.5701C14.6772 13.3793 14.4401 13.2838 14.1573 13.2838C13.8745 13.2838 13.6377 13.3795 13.4468 13.5708C13.2559 13.7621 13.1605 13.9992 13.1605 14.282C13.1605 14.5648 13.2561 14.8016 13.4474 14.9925C13.6387 15.1834 13.8758 15.2788 14.1586 15.2788Z'
                        fill='#333333'
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='p-3 mt-10 grid grid-cols-2 gap-7'>
            <div>
              <div className='mb-5'>
                <h3 className='job-info-header mb-2'>Job Summary</h3>
                <p className='job-info-text'>
                  {JobRequirementElement[0].props.children}
                </p>
              </div>
              <div className='mb-5'>
                <h3 className='job-info-header mb-2'>Job Qualification</h3>
                <p>Key Qualifications includes:</p>
                <ul className='text-[#141414] list-disc ml-8'>
                  {JobQualificationElement}
                </ul>
              </div>
              {/* <div className='mb-5'>
                <h3 className='job-info-header mb-2'>Job Requirements</h3>
                <p>Key job Requirements includes:</p>
                <ul className='text-[#141414] list-disc ml-8'>
                  {JobRequirementElement}
                </ul>
              </div> */}
              <div className='mb-5'>
                <h3 className='job-info-header mb-2'>Job responsibilities</h3>
                <p>Key job responsibilities includes:</p>
                <ul className='text-[#141414] list-disc ml-8'>
                  {JobResponsibilityElement}
                </ul>
              </div>
              <div className='mb-5'>
                <h3 className='job-info-header mb-2'>How to apply</h3>
                <p className='job-info-text'>
                  Send in your application via the Job Portal, and include your
                  past work experience and salary expectation.
                </p>
              </div>
              <div className='mb-5'>
                <h3 className='job-info-header mb-2'>NOTE:</h3>
                <p className='job-info-text'>
                  Kindly ensure your{" "}
                  <strong>
                    <Button
                      className='text-xl'
                      onClick={() => navigate("/profile")}
                      type='link'
                    >
                      Profile
                    </Button>
                  </strong>{" "}
                  is updated before submitting your Application.
                </p>
              </div>
            </div>

            <div>
              <div className='flex w-full justify-between'>
                <h3 className='job-info-header-cv mb-5'>Apply using CV</h3>
                <Button
                  onClick={() => navigate("/profile")}
                  className='bg-darkBlue text-white'
                  type='default'
                >
                  Update Profile
                </Button>
              </div>

              <Form
                layout='vertical'
                ref={formRef}
                name='control-ref'
                onFinish={onFinish}
                style={{
                  maxWidth: "100%",
                }}
                form={form}
              >
                <Form.Item
                  name='objYear'
                  label='Years of experience'
                  rules={[
                    {
                      required: true,
                      message: "Please add name",
                    },
                  ]}
                >
                  <Input className='rounded-[8px] h-[44px] w-full border border-black' />
                </Form.Item>

                {/* <Form.Item
                  name='objSalary'
                  label='Salary expectation'
                  rules={[
                    {
                      required: true,
                      message: "Please add name",
                    },
                  ]}
                >
                  <Input
                    type='number'
                    className='rounded-[8px] h-[44px] w-full border border-black'
                  />
                </Form.Item> */}
                <Form.Item
                  name='objGrade'
                  label='O Level Grade'
                  rules={[
                    {
                      required: true,
                      message: "Please enter grade e.g A, B -A",
                    },
                  ]}
                >
                  <Input className='rounded-[8px] h-[44px] w-full border border-black' />
                </Form.Item>
                <Form.Item>
                  <div className='flex flex-col mb-5'>
                    <label className='mb-2'>Attach CV</label>
                    <Dragger {...props}>
                      <div className='flex justify-center'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='29'
                          height='29'
                          viewBox='0 0 29 29'
                          fill='none'
                        >
                          <path
                            d='M25.375 18.125V22.9583C25.375 23.5993 25.1204 24.214 24.6672 24.6672C24.214 25.1204 23.5993 25.375 22.9583 25.375H6.04167C5.40073 25.375 4.78604 25.1204 4.33283 24.6672C3.87961 24.214 3.625 23.5993 3.625 22.9583V18.125'
                            stroke='#147CBC'
                            stroke-width='2'
                            stroke-linecap='round'
                            stroke-linejoin='round'
                          />
                          <path
                            d='M20.5423 9.66667L14.5007 3.625L8.45898 9.66667'
                            stroke='#147CBC'
                            stroke-width='2'
                            stroke-linecap='round'
                            stroke-linejoin='round'
                          />
                          <path
                            d='M14.5 3.625V18.125'
                            stroke='#147CBC'
                            stroke-width='2'
                            stroke-linecap='round'
                            stroke-linejoin='round'
                          />
                        </svg>
                        <p className='ant-upload-text !ml-2'>Upload</p>
                      </div>
                    </Dragger>
                  </div>
                </Form.Item>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message:
                        "KIndly check if you have read terms and conditions",
                    },
                  ]}
                  valuePropName='checked'
                >
                  <Checkbox
                    name='remember'
                    checked={checked}
                    onChange={onChange}
                  >
                    <div>
                      Kindly read the{" "}
                      <Button onClick={() => setOpen(true)} type='link'>
                        Declaration
                      </Button>{" "}
                      before submitting your application.
                    </div>
                  </Checkbox>
                </Form.Item>
                <div className='flex items-center justify-center mt-10'></div>
                <div className='flex items-center justify-center mt-10'>
                  <button
                    className='bg-darkBlue rounded-[35px] text-white w-[210px] p-2 ml-4'
                    type='submit'
                    disabled={isLoading}
                  >
                    {isLoading ? <Spin /> : <div>Apply</div>}
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <div className='w-full h-full overflow-y-hidden'>
        {/* <ProfileApplyDrawer open={open} onClose={onClose} /> */}
        <TermsOfService open={open} onClose={onClose} setChecked={setChecked} />
      </div>
    </>
  );
}
